<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Filter orders</ion-title>
        <ion-buttons *ngIf="online && !loading" slot="end">
            <ion-button (click)="clearFilters()">
                <fa-icon [icon]="['far', 'trash-alt']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
                <span>Clear</span>
            </ion-button>
            <ion-button (click)="filter()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <!-- TODO: filter by product, filter by discount code -->

    <ion-grid *ngIf="online && !loading" class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="timeframe_options" (ionCancel)="clearTimeframe()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['timeframe']">
                                <div slot="label">Timeframe<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option value="today">Today</ion-select-option>
                                <ion-select-option value="yesterday">Yesterday</ion-select-option>
                                <ion-select-option value="this_week">This week (Mon-Sun)</ion-select-option>
                                <ion-select-option value="last_week">Last week (Mon-Sun)</ion-select-option>
                                <ion-select-option value="this_month">This month</ion-select-option>
                                <ion-select-option value="last_month">Last month</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row >
                        <ion-col>
                            <ion-input *ngIf="filter_params['from_date'] && filter_params['from_date'].length != 0" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" value={{formatted_from_date}} (click)="presentFromDateTimePickerModal()">
                                <div slot="label">From date<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                            <ion-input *ngIf="!filter_params['from_date'] || filter_params['from_date'].length == 0" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentFromDateTimePickerModal()">
                                <div slot="label">From date<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row >
                        <ion-col>
                            <ion-input *ngIf="filter_params['to_date'] && filter_params['to_date'].length != 0" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" value={{formatted_to_date}} (click)="presentToDateTimePickerModal()">
                                <div slot="label">To date<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                            <ion-input *ngIf="!filter_params['to_date'] || filter_params['to_date'].length == 0" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentToDateTimePickerModal()">
                                <div slot="label">To date<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="is_awaiting_fulfillment_options" (ionCancel)="clearIsAwaitingFulfillment()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['is_awaiting_fulfillment']">
                                <div slot="label">Awaiting fulfillment<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option [value]="false">No</ion-select-option>
                                <ion-select-option [value]="true">Yes</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="is_awaiting_payment_options" (ionCancel)="clearIsAwaitingPayment()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['is_awaiting_payment']">
                                <div slot="label">Awaiting payment<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option [value]="false">No</ion-select-option>
                                <ion-select-option [value]="true">Yes</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="status_options" (ionCancel)="clearStatus()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['status']">
                                <div slot="label">Status<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option value="pending">Pending</ion-select-option>
                                <ion-select-option value="placed">Placed</ion-select-option>
                                <ion-select-option value="cancelled">Cancelled</ion-select-option>
                                <ion-select-option value="abandoned">Abandoned</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="payment_status_options" (ionCancel)="clearPaymentStatus()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['payment_status']">
                                <div slot="label">Payment status<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option value="unpaid">Unpaid</ion-select-option>
                                <ion-select-option value="partially_paid">Partially paid</ion-select-option>
                                <ion-select-option value="payment_held">Payment held</ion-select-option>
                                <ion-select-option value="paid">Paid</ion-select-option>
                                <ion-select-option value="voided">Voided</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="fulfillment_status_options" (ionCancel)="clearFulfillmentStatus()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['fulfillment_status']">
                                <div slot="label">Fulfilment status<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option value="unfulfilled">Unfulfilled</ion-select-option>
                                <ion-select-option value="partially_fulfilled">Partially fulfilled</ion-select-option>
                                <ion-select-option value="fulfilled">Fulfilled</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="return_status_options" (ionCancel)="clearReturnStatus()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['return_status']">
                                <div slot="label">Return status<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option value="partially_returned">Partially returned</ion-select-option>
                                <ion-select-option value="returned">Returned</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="refund_status_options" (ionCancel)="clearRefundStatus()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['refund_status']">
                                <div slot="label">Refund status<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option value="partially_refunded">Partially refunded</ion-select-option>
                                <ion-select-option value="refunded">Refunded</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="awaiting_payment_method_options" (ionCancel)="clearAwaitingPaymentMethod()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['awaiting_payment_method']">
                                <div slot="label">Awaiting payment method<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option value="credit_card">Credit card</ion-select-option>
                                <ion-select-option value="paypal">PayPal</ion-select-option>
                                <ion-select-option value="bank_transfer">Bank transfer</ion-select-option>
                                <ion-select-option value="purchase_order">Purchase order</ion-select-option>
                                <ion-select-option value="cash_on_delivery">Cash on delivery</ion-select-option>
                                <ion-select-option value="pay_in_store">Pay in-store</ion-select-option>
                                <ion-select-option value="pay_at_the_event">Pay at the event</ion-select-option>
                                <ion-select-option value="on_account">On account</ion-select-option>
                                <ion-select-option value="afterpay">Afterpay</ion-select-option>
                                <ion-select-option value="poli">POLi</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="channel_options" (ionCancel)="clearChannel()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['channel']">
                                <div slot="label">Channel<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option value="website">Website</ion-select-option>
                                <ion-select-option value="point_of_sale">Point of Sale</ion-select-option>
                                <ion-select-option value="recurring">Recurring</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="registers && registers.length != 0">
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="register_options" (ionCancel)="clearRegister()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['register_id']">
                                <div slot="label">Register<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option *ngFor="let register of registers" value="{{register.id}}">{{register.title}}</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="locations && locations.length != 0">
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="location_options" (ionCancel)="clearLocation()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['location_id']">
                                <div slot="label">Location<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option *ngFor="let location of locations" value="{{location.id}}">{{location.title}}</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="pricing_tiers && pricing_tiers.length != 0">
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="pricing_tier_options" (ionCancel)="clearPricingTier()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['pricing_tier_id']">
                                <div slot="label">Pricing tier<ion-text class="optional">optional</ion-text></div>
                                <ng-container *ngFor="let pricing_tier of pricing_tiers">
                                    <ion-select-option *ngIf="pricing_tier.sellable == true" value="{{pricing_tier.id}}">{{pricing_tier.title}}</ion-select-option>
                                </ng-container>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="supported_currencies && supported_currencies.length != 0">
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="currency_options" (ionCancel)="clearCurrency()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['currency_id']">
                                <div slot="label">Currency<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option *ngFor="let currency of supported_currencies" value="{{currency.id}}">{{currency.title}}</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="!hide_organisation_selector">
                        <ion-col>
                            <ion-input *ngIf="organisation_title" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" value={{organisation_title}} (click)="presentOrganisationPickerModal()">
                                <div slot="label">Organisation<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                            <ion-input *ngIf="!organisation_title" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentOrganisationPickerModal()">
                                <div slot="label">Organisation<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input *ngIf="affiliate_name" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" value={{affiliate_name}} (click)="presentAffiliatePickerModal()">
                                <div slot="label">Affiliate<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                            <ion-input *ngIf="!affiliate_name" class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentAffiliatePickerModal()">
                                <div slot="label">Affiliate<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="archived_options" (ionCancel)="clearArchived()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['archived']">
                                <div slot="label">Archived<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option [value]="false">No</ion-select-option>
                                <ion-select-option [value]="true">Yes</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>